import {
  SET_YC_PROFILE,
  SET_UPDATE_YC_PROFILE_ERRORS,
  SET_YC_PROFILE_USERS_ROLE,
  SET_YC_DASHBOARD,
  SET_YC_PROFILE_UPCOMING_EVENTS,
  SET_YC_PEOPLE_BAR,
  SET_YC_PEOPLE_ADD_LIST_USERS,
  SET_YC_PEOPLE_USERS,
  SET_YC_PEOPLE_USERS_SORT,
  SET_YC_PEOPLE_USERS_PAGE,
  SET_YC_PEOPLE_USERS_PER_PAGE,
  SET_YC_PEOPLE_LIST,
  SET_YC_PEOPLE_LIST_SORT,
  SET_YC_PEOPLE_LIST_PAGE,
  SET_YC_PEOPLE_LIST_PER_PAGE,
  SET_YC_EVENTS,
  SET_YC_EVENTS_BAR,
  SET_YC_EVENTS_PAGE,
  SET_YC_EVENTS_PER_PAGE,
  SET_YC_EVENTS_STATUS,
  SET_YC_PROJECTS,
  SET_YC_PROJECT,
  SET_YC_PROJECTS_BAR,
  SET_YC_PROJECTS_PAGE,
  SET_YC_PROJECTS_PER_PAGE,
  SET_YC_PROJECTS_STATUS,
  SET_YC_PROJECT_ROLES,
  SET_YC_PROJECT_ROLE,
  SET_YC_PROJECT_ROLES_BAR,
  SET_YC_PROJECT_ROLES_PAGE,
  SET_YC_PROJECT_ROLES_PER_PAGE,
  SET_YC_PROJECT_ROLES_STATUS,
  SET_YC_PROJECT_ROLE_APPLICATIONS,
  SET_YC_PROJECT_ROLE_APPLICATION_BAR,
  SET_YC_PROJECT_ROLE_APPLICATION_PAGE,
  SET_YC_PROJECT_ROLE_APPLICATION_PER_PAGE,
  SET_YC_PROJECT_ROLE_APPLICATION_STATUS,
  SET_YC_PEOPLE_USERS_FILTERS,
  SET_YC_PEOPLE_LIST_FILTERS,
  SET_YC_PEOPLE_APPLIED,
  SET_YC_PEOPLE_APPLIED_SORT,
  SET_YC_PEOPLE_APPLIED_PAGE,
  SET_YC_PEOPLE_APPLIED_PER_PAGE,
  SET_YC_PEOPLE_APPLIED_FILTERS,
  SET_YC_PEOPLE_MEMBERS,
  SET_YC_PEOPLE_MEMBERS_SORT,
  SET_YC_PEOPLE_MEMBERS_PAGE,
  SET_YC_PEOPLE_MEMBERS_PER_PAGE,
  SET_YC_PEOPLE_MEMBERS_FILTERS,
  SET_YC_REPORTS,
  SET_YC_REPORT,
  REMOVE_YC_REPORT,
  SET_YC_REPORT_ERRORS,
  SET_YC_REPORT_SAVED,
  SET_YC_MEETINGS,
  SET_YC_MEETINGS_PAGES,
  SET_YC_MEETINGS_PAGE,
  SET_YC_MEETINGS_TOTAL_ITEMS,
  SET_YC_MEETINGS_SORT,
  SET_YC_MEETINGS_FILTERS,
  SET_YC_MEETING_APPLICATION,
  REMOVE_YC_MEETING_APPLICATION,
  SET_YC_MEETING_APPLICATION_ERRORS,
} from '../constants';

const ycMeetingListInitialState = {
  filters: {},
  items: [],
  page: 1,
  pages: 1,
  perPage: 10,
  totalItems: 0,
  sort: null,
};

const setYcMeetingsListValue = (state, listType, values) => ({
  ...state,
  meetings: {
    ...state.meetings,
    [listType]: {
      ...state.meetings[listType],
      ...values,
    },
  },
});

const initialState = {
  profile: {
    data: null,
    usersRole: {},
    errors: {},
    upcomingEvents: [],
  },
  people: {
    users: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
    },
    list: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
    },
    applied: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
    },
    members: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
    },
    bar: {
      users: 0,
      people: 0,
      members: 0,
      applied: 0,
    },
    add: {
      data: [],
    },
  },
  events: {
    list: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      status: 'ongoing',
    },
    bar: {
      ongoing: 0,
      completed: 0,
      cancelled: 0,
      duplicate: 0,
    },
  },
  projects: {
    list: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      status: 'planning',
    },
    view: {},
    bar: {
      planning: 0,
      running: 0,
      completed: 0,
    },
  },
  projectRoles: {
    list: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      status: 'open',
    },
    view: {},
    bar: {
      open: 0,
      closed: 0,
      archived: 0,
    },
  },
  applications: {
    list: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      status: 'waiting',
    },
    bar: {
      open: 0,
      closed: 0,
      archived: 0,
    },
  },
  dashboard: {},
  reports: {
    // The list screen: the reports of earlier years plus whether a new one may
    // be started right now.
    items: [],
    schedule: null,
    canAddReport: false,
    currentReportId: null,
    // The form screen: everything one report needs, and the field errors the
    // API answered the last save with.
    form: {
      data: null,
      errors: {},
      // When the last draft was stored, so the form can confirm it inline.
      savedAt: null,
    },
  },
  // The meetings of the Young Crew profile, keyed by meeting type the way the
  // lists of the other profiles are, plus the application being worked on.
  meetings: {
    ycnda: { ...ycMeetingListInitialState },
    application: {
      data: null,
      errors: {},
    },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_YC_DASHBOARD:
      return { ...state, dashboard: action.payload };
    case SET_YC_PROFILE:
      return { ...state, profile: { ...state.profile, data: action.payload } };
    case SET_YC_PROFILE_USERS_ROLE:
      return { ...state, profile: { ...state.profile, usersRole: action.payload } };
    case SET_YC_PROFILE_UPCOMING_EVENTS:
      return { ...state, profile: { ...state.profile, upcomingEvents: action.payload } };
    case SET_UPDATE_YC_PROFILE_ERRORS:
      return { ...state, profile: { ...state.profile, errors: action.payload } };
    case SET_YC_PEOPLE_BAR:
      return { ...state, people: { ...state.people, bar: action.payload } };
    case SET_YC_PEOPLE_ADD_LIST_USERS:
      return {
        ...state,
        people: { ...state.people, add: { ...state.people.add, data: action.payload } },
      };
    case SET_YC_PEOPLE_USERS:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, ...action.payload } },
      };
    case SET_YC_PEOPLE_USERS_SORT:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, sort: action.payload } },
      };
    case SET_YC_PEOPLE_USERS_PAGE:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, page: action.payload } },
      };
    case SET_YC_PEOPLE_USERS_PER_PAGE:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, perPage: action.payload } },
      };
    case SET_YC_PEOPLE_USERS_FILTERS:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, filters: action.payload } },
      };
    case SET_YC_PEOPLE_LIST:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, ...action.payload } },
      };
    case SET_YC_PEOPLE_LIST_SORT:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, sort: action.payload } },
      };
    case SET_YC_PEOPLE_LIST_PAGE:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, page: action.payload } },
      };
    case SET_YC_PEOPLE_LIST_PER_PAGE:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, perPage: action.payload } },
      };
    case SET_YC_PEOPLE_LIST_FILTERS:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, filters: action.payload } },
      };
    case SET_YC_PEOPLE_APPLIED:
      return {
        ...state,
        people: { ...state.people, applied: { ...state.people.applied, ...action.payload } },
      };
    case SET_YC_PEOPLE_APPLIED_SORT:
      return {
        ...state,
        people: { ...state.people, applied: { ...state.people.applied, sort: action.payload } },
      };
    case SET_YC_PEOPLE_APPLIED_PAGE:
      return {
        ...state,
        people: { ...state.people, applied: { ...state.people.applied, page: action.payload } },
      };
    case SET_YC_PEOPLE_APPLIED_PER_PAGE:
      return {
        ...state,
        people: { ...state.people, applied: { ...state.people.applied, perPage: action.payload } },
      };
    case SET_YC_PEOPLE_APPLIED_FILTERS:
      return {
        ...state,
        people: { ...state.people, applied: { ...state.people.applied, filters: action.payload } },
      };
    case SET_YC_PEOPLE_MEMBERS:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, ...action.payload } },
      };
    case SET_YC_PEOPLE_MEMBERS_SORT:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, sort: action.payload } },
      };
    case SET_YC_PEOPLE_MEMBERS_PAGE:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, page: action.payload } },
      };
    case SET_YC_PEOPLE_MEMBERS_PER_PAGE:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, perPage: action.payload } },
      };
    case SET_YC_PEOPLE_MEMBERS_FILTERS:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, filters: action.payload } },
      };
    case SET_YC_EVENTS:
      return {
        ...state,
        events: {
          ...state.events,
          list: {
            ...state.events.list,
            ...action.payload,
          },
        },
      };
    case SET_YC_EVENTS_BAR:
      return {
        ...state,
        events: {
          ...state.events,
          bar: action.payload,
        },
      };
    case SET_YC_EVENTS_PAGE:
      return {
        ...state,
        events: { ...state.events, list: { ...state.events.list, page: action.payload } },
      };
    case SET_YC_EVENTS_PER_PAGE:
      return {
        ...state,
        events: { ...state.events, list: { ...state.events.list, perPage: action.payload } },
      };
    case SET_YC_EVENTS_STATUS:
      return {
        ...state,
        events: {
          ...state.events,
          list: {
            ...state.events.list,
            page: state.events.list.status !== action.payload ? 1 : state.events.list.page,
            status: action.payload,
          },
        },
      };
    case SET_YC_PROJECTS:
      return {
        ...state,
        projects: {
          ...state.projects,
          list: {
            ...state.projects.list,
            ...action.payload,
          },
        },
      };
    case SET_YC_PROJECT:
      return {
        ...state,
        projects: {
          ...state.projects,
          view: action.payload,
        },
      };
    case SET_YC_PROJECTS_BAR:
      return {
        ...state,
        projects: {
          ...state.projects,
          bar: action.payload,
        },
      };
    case SET_YC_PROJECTS_PAGE:
      return {
        ...state,
        projects: { ...state.projects, list: { ...state.projects.list, page: action.payload } },
      };
    case SET_YC_PROJECTS_PER_PAGE:
      return {
        ...state,
        projects: { ...state.projects, list: { ...state.projects.list, perPage: action.payload } },
      };
    case SET_YC_PROJECTS_STATUS:
      return {
        ...state,
        projects: {
          ...state.projects,
          list: {
            ...state.projects.list,
            page: state.projects.list.status !== action.payload ? 1 : state.projects.list.page,
            status: action.payload,
          },
        },
      };
    case SET_YC_PROJECT_ROLES:
      return {
        ...state,
        projectRoles: {
          ...state.projectRoles,
          list: {
            ...state.projectRoles.list,
            ...action.payload,
          },
        },
      };
    case SET_YC_PROJECT_ROLE:
      return {
        ...state,
        projectRoles: {
          ...state.projectRoles,
          view: action.payload,
        },
      };
    case SET_YC_PROJECT_ROLES_BAR:
      return {
        ...state,
        projectRoles: {
          ...state.projectRoles,
          bar: action.payload,
        },
      };
    case SET_YC_PROJECT_ROLES_PAGE:
      return {
        ...state,
        projectRoles: {
          ...state.projectRoles,
          list: { ...state.projectRoles.list, page: action.payload },
        },
      };
    case SET_YC_PROJECT_ROLES_PER_PAGE:
      return {
        ...state,
        projectRoles: {
          ...state.projectRoles,
          list: { ...state.projectRoles.list, perPage: action.payload },
        },
      };
    case SET_YC_PROJECT_ROLES_STATUS:
      return {
        ...state,
        projectRoles: {
          ...state.projectRoles,
          list: {
            ...state.projectRoles.list,
            page:
              state.projectRoles.list.status !== action.payload ? 1 : state.projectRoles.list.page,
            status: action.payload,
          },
        },
      };
    case SET_YC_PROJECT_ROLE_APPLICATIONS:
      return {
        ...state,
        applications: {
          ...state.applications,
          list: {
            ...state.applications.list,
            ...action.payload,
          },
        },
      };
    case SET_YC_PROJECT_ROLE_APPLICATION_BAR:
      return {
        ...state,
        applications: {
          ...state.applications,
          bar: action.payload,
        },
      };
    case SET_YC_PROJECT_ROLE_APPLICATION_PAGE:
      return {
        ...state,
        applications: {
          ...state.applications,
          list: { ...state.applications.list, page: action.payload },
        },
      };
    case SET_YC_PROJECT_ROLE_APPLICATION_PER_PAGE:
      return {
        ...state,
        applications: {
          ...state.applications,
          list: { ...state.applications.list, perPage: action.payload },
        },
      };
    case SET_YC_PROJECT_ROLE_APPLICATION_STATUS:
      return {
        ...state,
        applications: {
          ...state.applications,
          list: {
            ...state.applications.list,
            page:
              state.applications.list.status !== action.payload ? 1 : state.applications.list.page,
            status: action.payload,
          },
        },
      };
    case SET_YC_REPORTS:
      return {
        ...state,
        reports: {
          ...state.reports,
          items: action.payload.items || [],
          schedule: action.payload.schedule || null,
          canAddReport: !!action.payload.canAddReport,
          currentReportId: action.payload.currentReportId || null,
        },
      };
    case SET_YC_REPORT:
      return {
        ...state,
        reports: {
          ...state.reports,
          form: { data: action.payload, errors: {}, savedAt: null },
        },
      };
    case SET_YC_REPORT_SAVED:
      return {
        ...state,
        reports: {
          ...state.reports,
          form: { ...state.reports.form, savedAt: action.payload },
        },
      };
    case REMOVE_YC_REPORT:
      return {
        ...state,
        reports: {
          ...state.reports,
          form: { data: null, errors: {}, savedAt: null },
        },
      };
    case SET_YC_REPORT_ERRORS:
      return {
        ...state,
        reports: {
          ...state.reports,
          form: { ...state.reports.form, errors: action.payload },
        },
      };
    case SET_YC_MEETINGS:
      return setYcMeetingsListValue(state, action.listType, { items: action.payload });
    case SET_YC_MEETINGS_PAGES:
      return setYcMeetingsListValue(state, action.listType, { pages: action.payload });
    case SET_YC_MEETINGS_PAGE:
      return setYcMeetingsListValue(state, action.listType, { page: action.payload });
    case SET_YC_MEETINGS_TOTAL_ITEMS:
      return setYcMeetingsListValue(state, action.listType, { totalItems: action.payload });
    case SET_YC_MEETINGS_SORT:
      return setYcMeetingsListValue(state, action.listType, { sort: action.payload });
    case SET_YC_MEETINGS_FILTERS:
      return setYcMeetingsListValue(state, action.listType, {
        filters: {
          ...state.meetings[action.listType].filters,
          [action.payload.name]: action.payload.value,
        },
      });
    case SET_YC_MEETING_APPLICATION:
      return {
        ...state,
        meetings: { ...state.meetings, application: { data: action.payload, errors: {} } },
      };
    case SET_YC_MEETING_APPLICATION_ERRORS:
      return {
        ...state,
        meetings: {
          ...state.meetings,
          application: { ...state.meetings.application, errors: action.payload },
        },
      };
    case REMOVE_YC_MEETING_APPLICATION:
      return {
        ...state,
        meetings: { ...state.meetings, application: { data: null, errors: {} } },
      };
    default:
      return state;
  }
};
